import {observer} from 'mobx-react-lite';
import {AgentList} from './AgentList';
import {useState} from 'react';

const UserAdmin = observer(() => {
    return (
        <div style={{width: '100%'}}>
            <AgentList />
        </div>
    );
});

export default UserAdmin;
